import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

export default class CustomVectorLayer<VectorSourceType extends VectorSource<any>> extends VectorLayer<VectorSourceType> {
}